import { IConfig } from './IConfig';

export type LanguageId = 'en' | 'de' | 'fr' | 'nl';

export const LanguageDict: Record<LanguageId, string> = {
  en: 'English',
  de: 'Deutsch',
  fr: 'Français',
  nl: 'Nederlands',
};

abstract class ProfileConfig implements IConfig {
  protected readonly defaultPathPrefix = '/viewlets/consent/consent-manager';

  constructor(baseId: string, supportedLanguageKeys: Array<string>, profilePrefix: string) {
    supportedLanguageKeys.forEach((key: string) => (this.SupportedLanguages[key] = LanguageDict[key as LanguageId]));
    this.DefaultLanguage = supportedLanguageKeys[0];
    this.Profile = `${profilePrefix}-${baseId}`;
  }

  Profile: string;
  DefaultLanguage: string;
  ProfileId: string;
  ResourcePath: string;
  SupportedLanguages?: { [name: string]: string } = {};
}

export { ProfileConfig };
